import { render, staticRenderFns } from "./KaynaklarInfo.vue?vue&type=template&id=748bf656&scoped=true"
import script from "./KaynaklarInfo.vue?vue&type=script&lang=ts"
export * from "./KaynaklarInfo.vue?vue&type=script&lang=ts"
import style0 from "./KaynaklarInfo.vue?vue&type=style&index=0&id=748bf656&prod&lang=scss&scoped=true"
import style1 from "./KaynaklarInfo.vue?vue&type=style&index=1&id=748bf656&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748bf656",
  null
  
)

export default component.exports